export const getLoaderWidth = (
  width: number,
  originalImageDimensions?: { x: number; y: number },
) => {
  // the deviceSizes in next.config have larger size(like 3840, 2048),
  // when the width big than origin image width, set width = origin image width
  return originalImageDimensions?.x && width > originalImageDimensions.x
    ? originalImageDimensions.x
    : width;
};
